enum ReceiptContentType {
	Standard,
	Demo,
	DeviceTest,
	CashBoxTotals,
	Custom,
}

export default ReceiptContentType;
